import React, { useEffect, useRef, useState } from 'react';
import img5 from '../assets/imagen_5.jpeg';
import img6 from '../assets/imagen_6.jpeg';
import img7 from '../assets/imagen_7.jpeg';
import img8 from '../assets/imagen_8.jpeg';
import img9 from '../assets/imagen_9.jpeg';
import img10 from '../assets/imagen_10.jpeg';
import img11 from '../assets/imagen_11.jpeg';
import img12 from '../assets/imagen_12.jpeg';
import img13 from '../assets/imagen_13.jpeg';
import img14 from '../assets/imagen_14.jpeg';

export default function Carousel({ images }) {
  const gallery = images || [img5, img6, img7, img8, img9, img10, img11, img12, img13, img14];
  const [index, setIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const timeoutRef = useRef(null);
  const INTERVAL = 3500;

  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  function startAutoplay() {
    stopAutoplay();
    timeoutRef.current = setTimeout(() => {
      setIndex((i) => (i + 1) % gallery.length);
    }, INTERVAL);
  }

  function stopAutoplay() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }

  function prev() {
    stopAutoplay();
    setIndex((i) => (i === 0 ? gallery.length - 1 : i - 1));
  }

  function next() {
    stopAutoplay();
    setIndex((i) => (i + 1) % gallery.length);
  }

  function openModal(imgIndex) {
    setModalIndex(imgIndex);
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
  }

  function modalPrev() {
    setModalIndex((i) => (i === 0 ? gallery.length - 1 : i - 1));
  }

  function modalNext() {
    setModalIndex((i) => (i + 1) % gallery.length);
  }

  return (
    <div className="w-full">
      <div className="relative rounded-2xl overflow-hidden bg-gray-100 shadow-lg">
        <img 
          src={gallery[index]} 
          alt={`Entrega ${index + 1}`} 
          onClick={() => openModal(index)}
          className="w-full h-80 sm:h-[420px] object-cover cursor-pointer hover:opacity-90 transition-opacity" 
        />

        {/* Left / Right controls */}
        <button onClick={prev} aria-label="Anterior" className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow">
          <svg className="w-5 h-5 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <button onClick={next} aria-label="Siguiente" className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow">
          <svg className="w-5 h-5 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg>
        </button>

        {/* Dots */}
        <div className="absolute left-1/2 -translate-x-1/2 bottom-3 flex gap-2">
          {gallery.map((_, i) => (
            <button
              key={i}
              onClick={() => { stopAutoplay(); setIndex(i); }}
              aria-label={`Ir a imagen ${i + 1}`}
              className={`w-2.5 h-2.5 rounded-full ${i === index ? 'bg-white' : 'bg-white/60'} shadow`}
            />
          ))}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="mt-4 grid grid-cols-5 sm:grid-cols-10 gap-2">
        {gallery.map((src, i) => (
          <button key={i} onClick={() => { stopAutoplay(); setIndex(i); }} className={`overflow-hidden rounded-md border ${i === index ? 'border-amber-500' : 'border-transparent'} focus:outline-none hover:opacity-80 transition-opacity`}>
            <img src={src} alt={`Mini ${i + 1}`} className="w-full h-16 object-cover cursor-pointer" />
          </button>
        ))}
      </div>

      {/* Modal Lightbox */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 p-4">
          {/* Close button */}
          <button
            onClick={closeModal}
            aria-label="Cerrar"
            className="absolute top-4 right-4 bg-white/90 hover:bg-white rounded-full p-2 shadow-lg z-10"
          >
            <svg className="w-6 h-6 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>

          {/* Left button */}
          <button
            onClick={modalPrev}
            aria-label="Anterior"
            className="absolute left-4 bg-white/80 hover:bg-white rounded-full p-3 shadow-lg"
          >
            <svg className="w-6 h-6 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>

          {/* Image */}
          <img
            src={gallery[modalIndex]}
            alt={`Ampliada ${modalIndex + 1}`}
            className="max-w-4xl max-h-[90vh] object-contain rounded-lg shadow-2xl"
          />

          {/* Right button */}
          <button
            onClick={modalNext}
            aria-label="Siguiente"
            className="absolute right-4 bg-white/80 hover:bg-white rounded-full p-3 shadow-lg"
          >
            <svg className="w-6 h-6 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>

          {/* Counter */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white/90 px-4 py-2 rounded-full text-sm font-medium text-gray-800">
            {modalIndex + 1} / {gallery.length}
          </div>
        </div>
      )}
    </div>
  );
}
